import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_279: DocMigration = {
  maxSchemaVersion: "0.0.279",
  description: "Set dimension padding on existing homes to maintain baselines",
  apply(json: any) {
    if (!json.settings) {
      return json;
    }

    const settingsSetId = uid();
    const settingsSet = {
      entityType: "SETTINGS_SET",
      name: "Exterior Dimension Plan Settings",
      id: settingsSetId,
      sortIndex: 0,
    };

    const planSettingsId = uid();
    const planSettings = {
      entityType: "SETTINGS",
      type: "PLAN_SETTINGS",
      id: planSettingsId,
      name: "Plan Settings",
      sortIndex: 0,
      parentId: settingsSetId,
      exteriorDimensionOffsetMultiplier: 0.8,
    };

    json.settings[planSettingsId] = planSettings;
    json.settingsSets[settingsSetId] = settingsSet;

    return json;
  },
};

export default migration_0_0_279;
